import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { IRecommendedServicePackage } from '../../../../reducers';

export function mapServicePackageTerm(recommendedPackage: IRecommendedServicePackage): ICheckPublishTermSchema {
  const { id: recommendedServicePackageId, services } = recommendedPackage;

  return {
    days: 1,
    services,
    recommendedServicePackageId,
  };
}
